import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";

import { Button, makeStyles, Paper, Link, TextField, Typography } from '@material-ui/core'

import api from '../../utils/api';
import { startRefreshTokenTimer } from '../../utils/refreshToken';
import { useDispatch } from 'react-redux';
import { setUser } from '../../actions';
import { FormElementWrapper } from '../../components/EditorFormElements';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    background: "transparent linear-gradient(180deg, #005B9700 0%, #0061A219 19%, #0061A241 40%, #0061A280 65%, #0061A2F2 100%) bottom no-repeat;",
    backgroundSize: '100% 55%',
    '&::before': {
      content: '""',
      background: '#fff',
      opacity: .2,
      transformOrigin: 'bottom left',
      transform: 'skew(25.5deg)', 
      position: 'absolute',
      left: 0,
      width: '58vw',
      height: '100vh',
    }
  },
  scrollWrapper: {
    position: 'relative',
    overflow: 'auto',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 40,
  },
  logo: {
    marginTop: 'auto',
    width: 400,
  },
  paper: {
    margin: '40px 0 auto 0',
    padding: '50px 50px 28px 50px',
    textAlign: 'center',
    borderRadius: 10,
  },
  textWrapper: {
    maxWidth: 460,
  },
  title: {
    fontWeight: 500,
    fontSize: 36,
    marginBottom: 18
  },
  description: {
    color: theme.palette.neutral.dark2,
    fontSize: 18,
    lineHeight: '26px',
  },
  button: {
    margin: '0 0 35px 0',
    textTransform: 'none',
    fontSize: 17,
    padding: '8px 18px',
  },
  help: {
    fontSize: 14,
    color: theme.palette.neutral.dark2,
  },
  link: {
    textDecoration: 'underline'
  },
  inputWrapper : {
    width: 350,
    margin: '15px auto',
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
}))

export const Login = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [un, setUsername] = useState('');
  const [pw, setPassword] = useState('');
  const [authError, setAuthError] = useState('');

  useEffect(() => {
    document.title = "Log In | PAVILION Interactive Builder";
  }, []);


  const handleLogin = (e) => {
    e.preventDefault();

    // Send login details to BE
    api.login({
      "email": un,
      "password": pw
    })
    .then(res => {
      startRefreshTokenTimer(res.data)
      dispatch(setUser(res.data));

      // Redirect if query parameter exists
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get('redirect');
        history.push(redirect);
      } else {
        history.push('/')
      }
      
    })
    .catch(err => {
      // Display error if fails
      if (!err.response || err.response.status !== 401) {
        setAuthError("Server error. Please contact support.");
      } else if (err.response.status === 401) {
        setAuthError("Your username or password is incorrect.");
      }
    });
    
  }

  return (
    <div className={classes.root}>
      <div className={classes.scrollWrapper}>
        
        {/* Logo */}
        <img className={classes.logo} src={require("../../images/logo-interactive-builder.png")} alt="Pavilion Interactive Builder"/>
        
        {/* "Dialog" box */}
        <Paper className={classes.paper}>

          {/* Headline */}
          <div className={classes.textWrapper}>
            <Typography variant="h4" component="h1" className={classes.title} >Get Started</Typography>
            <Typography className={classes.description}>Creating interactives for PAVILION, the DINFOS online learning tool.</Typography>
          </div>

          {/* Form */}
          <form onSubmit={handleLogin}>
            <div className={classes.inputWrapper}>
              
              {/* Error message */}
              <div className={classes.errorMessage}>
                {authError}
              </div>

              {/* Username */}
              <FormElementWrapper>
                <TextField 
                  variant="outlined"
                  id="username"
                  label="Username" 
                  name="username"
                  value={un}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </FormElementWrapper>

              {/* Password */}
              <FormElementWrapper>
                <TextField 
                  variant="outlined"
                  id="password"
                  label="Password" 
                  name="password"
                  value={pw}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                />
              </FormElementWrapper>
            </div>

            {/* Submit */}
            <Button 
              variant="contained"
              color="primary"
              // endIcon={<i className="fas fa-address-card"></i>}
              className={classes.button}
              type="submit"
              disabled={!un || !pw}
            >
              Log in
            </Button>
          </form>

          {/* Email link */}
          <Typography className={classes.help}>
            Need help?
            <br/>
            <Link className={classes.link} href="mailto:pavilion@dinfos.edu?subject=Need support with PAVILION Interactive Builder Tool">Contact support</Link> for access.
          </Typography>

        </Paper>

      </div>
    </div>
  )
}